<template>
  <form
    id="genres-signup-form"
    method="POST"
    :action="formSubmitUrl"
    @submit="trackEvent($event)"
  >
    <div class="grid-7">
      <input
        hidden
        name="interest"
        :value="genreSlug"
      >
      <input
        hidden
        name="v3_captcha_token"
        value="not-a-real-v3-token"
      >

      <div class="grid-item-5">
        <input
          type="email"
          class="input-full"
          placeholder="Enter your email address..."
          required
        >
      </div>
      <div class="grid-item-2">
        <button
          class="button-yellow button-full button-lg"
          type="submit"
        >
          Sign up
        </button>
      </div>
    </div>

    <DFormRecaptcha
      action-name="discovery_signup_genre"
      form-id="genres-signup-form"
      :recaptcha-v3-key="recaptchaKey"
    />
  </form>
</template>

<script>
import Vue from 'vue';
import DFormRecaptcha from '../d-form-recaptcha/d-form-recaptcha.vue';
import URLS from '@d-shared/urls/urls';

export default {
  components: {
    DFormRecaptcha,
  },
  props: {
    genreSlug: {
      type: String,
      required: true,
    },
    recaptchaKey: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    formSubmitUrl: URLS.app.signUp.regular,
  }),
  methods: {
    trackEvent(event) {
      Vue.prototype.eventsTracking.trackAndSubmitForm(
        'sign-up-request',
        {
          type: 'form',
          location: 'genre-page',
          method: 'email',
        },
        event.target,
      );
    },
  },
};
</script>
